import { apiGet } from 'App/Dataman';
import { SOCIAL_MEDIA_SCRAPER_PATHS } from '@/app/api/socialMediaScraper/paths';

export function getInstagramResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.instagram, { params });
}

export function getFacebookResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.facebook, { params });
}

export function getXResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.x, { params });
}

export function getYoutubeResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.youtube, { params });
}

export function getLinkedinResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.linkedin, { params });
}

export function getSocialMediaProductTypes(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.productTypes, { params });
}

export function getSocialMediaApplications(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.applications, { params });
}

export function getSocialMediaEffects(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.effects, { params });
}

export function getSocialMediaNewLaunches(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.newLaunches, { params });
}

export function getSocialMediaIngredients(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.ingredients, { params });
}

export function getSocialMediaAllResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.all, { params });
}

export default {
  getInstagramResults,
  getFacebookResults,
  getXResults,
  getYoutubeResults,
  getLinkedinResults,
  getSocialMediaProductTypes,
  getSocialMediaApplications,
  getSocialMediaEffects,
  getSocialMediaNewLaunches,
  getSocialMediaIngredients,
  getSocialMediaAllResults,
};
